import React, { useEffect, useState } from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
import HeadingH1 from "../../../utls/HeadingH1";

const BusinessTravelBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div
          className="container-fluid ctm-banner position-relative p-0"
          style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
        >
          <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/17.%20Business%20Travel.webp"
            alt="Contact Banner"
            className="w-100"
            // For high-speed, use eager loading; for low-speed, lazy loading.
            loading={useHighRes ? "eager" : "lazy"}
            // Attach the onLoad handler only for high-speed connections.
            onLoad={useHighRes ? handleImageLoad : undefined}
            fetchpriority={useHighRes ? "high" : "auto"}
          />
          {imageLoaded &&
            <div className="ctm-text position-absolute text-white  mt-3">
              <p className="fs4 text-uppercase busy grotesk-headings">
                REVOLUTIONIZING
              </p>
              <HeadingH1 className="banner-headings w-100">
                Seamless Access <br />
                from Everywhere
              </HeadingH1>
              <div className="d-flex common-second-content">
                <div className="ornge-border"></div>
                <div className="second-content">
                  Do you know the secret to smoother business travel? It’s
                  Blueberry Travel. We deliver personalized travel solutions
                  that keep your team on track.
                </div>
              </div>
            </div>
             }
        </div>
      )}
    </BannerWrapper>
  );
};

export default BusinessTravelBanner;
